import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PostCard.module.css';

interface PostCardProps {
    id: number;
    title: string;
    date: string;
    excerpt: string;
    category: string;
    isHoliday?: boolean;
}

const PostCard: React.FC<PostCardProps> = ({
                                               id,
                                               title,
                                               date,
                                               excerpt,
                                               category,
                                               isHoliday = false
                                           }) => {
    const navigate = useNavigate();

    const handleReadMore = (): void => {
        navigate(`/post/${id}`);
    };

    return (
        <article className={`${styles.card} ${isHoliday ? styles.holiday : ''}`}>
            <div className={styles.category}>{category}</div>
            <div className={styles.content}>
                <h2 className={styles.title}>{title}</h2>
                <time className={styles.date}>{date}</time>
                <p className={styles.excerpt}>{excerpt}</p>
                <button onClick={handleReadMore} className={styles.readMore}>
                    Читать далее
                </button>
            </div>
        </article>
    );
};

export default PostCard;